import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const ShiftSchedule = lazy(() =>
    import('@/v1/management/views/ShiftSchedule').then((module) => ({
        default: module.ShiftSchedule,
    }))
);

const HistoryShiftSchedule = lazy(() =>
    import('@/v1/management/views/HistoryShiftSchedule').then((module) => ({
        default: module.HistoryShiftSchedule,
    }))
);

export const shiftScheduleRoutes: RouteObject[] = [
    {
        path: `realtime`,
        ...PageElement(<ShiftSchedule />),
    },
    {
        path: `history`,
        ...PageElement(<HistoryShiftSchedule />),
    },
];
